import React, { useContext } from 'react';
import { func } from 'prop-types';

// Components
import { Box, Typography } from '@mui/material';
import Buttons from '../../components/Buttons';
import SummaryContent from '../../components/SummaryContent';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const PrimaryStep5 = ({ prev, next }) => {
  const {
    data: { changeList, inventoryOwners = [] },
  } = useContext(SequencingWizardContext);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100% - 157px)',
          mb: '46px',
          overflowY: 'auto',
          pt: 3,
        }}
      >
        <Box pb={3} px={3} textAlign="center">
          <Typography
            sx={{
              marginBottom: '16px',
            }}
            variant="h6"
          >
            Confirm New Primary
          </Typography>
          <Typography
            sx={{
              marginBottom: '16px',
            }}
            variant="body1"
          >
            {inventoryOwners[0]?.companyCustomerIdName} {inventoryOwners[0]?.nameShort} will be{' '}
            <u>inserted</u> as the primary Inventory Owner for the following locations and products.
            Any existing Inventory Owners currently sequenced will be moved to the next sequencing
            slot.
          </Typography>
          <Typography variant="body1">
            There could be a total of {changeList.length} change{changeList.length > 1 ? 's' : ''}.
            This change can take up to 15 minutes to take affect at all locations.
          </Typography>
        </Box>
        <SummaryContent inventoryOwnerSubtitle="Primary Inventory Owner" />
      </Box>
      <Buttons
        disabled={false}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={false}
        rightLabel="Submit"
      />
    </>
  );
};

PrimaryStep5.propTypes = {
  next: func.isRequired,
  prev: func.isRequired,
};

export default PrimaryStep5;
